import { Component, Input } from "@angular/core"
import { LMModalService } from "../../services/lm-modal.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"

@Component({
    selector: "app-favorite-button",
    templateUrl: "./favorite-button.component.html",
    styleUrls: ["./favorite-button.component.scss"],
})
export class FavoriteButtonComponent extends EduComponent {
    public favoriteId: number = null
    public isLoading: boolean = true

    @Input() public learningObjectId: string
    @Input() public hideLabelOnMobile: boolean
    @Input() public hideLabelOnSmallDevices: boolean
    @Input() public hideLabelOnTablet: boolean
    @Input() public isLarge: boolean = false
    @Input() public loggedinTooltip: string = null
    @Input() public loggedoutTooltip: string = null
    @Input() public gtmLabel?: string = ""

    public constructor(public userService: UserService, private lmModalService: LMModalService) {
        super()
    }

    public ngOnChanges() {
        this.clearSubs()
        this.addSub(
            this.userService.favoritesReady.subscribe((favorites) => {
                const favorite = (favorites || []).find(
                    (favoriteObj) => favoriteObj.loId === this.learningObjectId
                )
                this.favoriteId = favorite ? favorite.favoriteId : null
                this.isLoading = false
            })
        )
    }

    public onFavoriteClick() {
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal()
            return
        }
        if (this.isLoading) {
            return
        }
        if (this.favoriteId) {
            this.userService.deleteFavorite(this.favoriteId)
        } else {
            this.userService.addFavorite(this.learningObjectId)
        }
        this.isLoading = true
    }
}
